import { PriceSuggestionPriority, PriceSuggestionType } from '@retail/products/types';
import { dateFromString } from '@retail/utils';
import { CalculusConditionDTO } from '../../dtos';
import { ConditionBaseProps, ItemConditionBase } from '../ConditionBase';
import { SupplierBase } from '@retail/suppliers/types';

export interface PriceSuggestionConditionProps
  extends ConditionBaseProps<PriceSuggestionCondition> {
  actualPriceSuggestionType?: PriceSuggestionType;
  priceSuggestionType?: PriceSuggestionType;
  priceSuggestionPriorities?: PriceSuggestionPriority[];
}

export class PriceSuggestionCondition extends ItemConditionBase<PriceSuggestionCondition> {
  actualPriceSuggestionType?: PriceSuggestionType;
  priceSuggestionType?: PriceSuggestionType;
  priceSuggestionPriorities?: PriceSuggestionPriority[];

  constructor({
    actualPriceSuggestionType,
    priceSuggestionType,
    priceSuggestionPriorities,
    ...superProps
  }: PriceSuggestionConditionProps) {
    super(superProps);
    this.actualPriceSuggestionType = actualPriceSuggestionType;
    this.priceSuggestionType = priceSuggestionType;
    this.priceSuggestionPriorities = priceSuggestionPriorities;
  }

  static fromDto = (dto: CalculusConditionDTO): PriceSuggestionCondition =>
    new PriceSuggestionCondition({
      id: dto.id,
      assortmentId: dto.assortmentId,
      assortmentName: dto.assortmentName,
      inDraft: dto.inDraft,
      type: dto.type,
      supplier: dto.supplier ? SupplierBase.fromDto(dto.supplier) : undefined,
      bindingType: dto.bindingType,
      bindingTarget: dto.bindingTarget,
      bindingTargetName: dto.bindingTargetName,
      bindingTargetId: dto.bindingTargetId,
      bindingTargetItem: dto.bindingTargetItem,
      validFrom: new Date(dto.validFrom),
      validTo: dateFromString(dto.validTo),
      actualPriceSuggestionType: dto.actualPriceSuggestionType,
      priceSuggestionType: dto.priceSuggestionType,
      priceSuggestionPriorities: dto.priceSuggestionPriorities,
    });
}
